export const monthlyData = [
  { month: "Gen", preventivi: 7, polizze: 3, premi: 1700 },
  { month: "Feb", preventivi: 7, polizze: 4, premi: 2050 },
  { month: "Mar", preventivi: 9, polizze: 5, premi: 2200 },
  { month: "Apr", preventivi: 0, polizze: 0, premi: 0 },
  { month: "Mag", preventivi: 0, polizze: 0, premi: 0 },
  { month: "Giu", preventivi: 0, polizze: 0, premi: 0 },
  { month: "Lug", preventivi: 0, polizze: 0, premi: 0 },
  { month: "Ago", preventivi: 0, polizze: 0, premi: 0 },
  { month: "Set", preventivi: 0, polizze: 0, premi: 0 },
  { month: "Ott", preventivi: 0, polizze: 0, premi: 0 },
  { month: "Nov", preventivi: 0, polizze: 0, premi: 0 },
  { month: "Dic", preventivi: 0, polizze: 0, premi: 0 },
];

export const ramoData = [
  { ramo: "RCA", prev: 9, polizze: 6, conv: "66.7%", premi: "€ 3.3K", medio: "€ 552", color: "#3B82F6" },
  { ramo: "Incendio/Furto", prev: 4, polizze: 2, conv: "50.0%", premi: "€ 780", medio: "€ 390", color: "#F97316" },
  { ramo: "Kasko", prev: 3, polizze: 0, conv: "0.0%", premi: "€ 0", medio: "€ 0", color: "#8B5CF6" },
  { ramo: "Assistenza", prev: 3, polizze: 1, conv: "33.3%", premi: "€ 130", medio: "€ 130", color: "#22C55E" },
  { ramo: "Tutela Legale", prev: 3, polizze: 3, conv: "100.0%", premi: "€ 690", medio: "€ 230", color: "#06B6D4" },
  { ramo: "Infortuni Conducente", prev: 1, polizze: 0, conv: "0.0%", premi: "€ 0", medio: "€ 0", color: "#EC4899" },
];

export const yearFilterOptions = ["Oggi", "Ultimi 7 giorni", "Mese corrente", "Ultimo trimestre", "Anno corrente"];

export const ramoFilterOptions = [
  "Tutti i rami",
  "RCA",
  "Incendio/Furto",
  "Kasko",
  "Assistenza",
  "Tutela Legale",
  "Infortuni Conducente",
];

export const chartTabs = ["Volumi (€)", "Pratiche", "Conversione %"];
